import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"search\"><g fill=\"none\" fill-rule=\"evenodd\"><path /><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M9.5 15a5.5 5.5 0 110-11 5.5 5.5 0 010 11m12.2 5.3L15.5 14c1-1.3 1.5-2.9 1.5-4.6a7.5 7.5 0 10-3 6l6.3 6.2a1 1 0 001.4-1.4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol